import '@chewy/kib-global/dist/kib-global.css'
import '@chewy/kib-css-helpers/dist/kib-css-helpers.css'
import '@chewy/kib-tokens/build/_variables.css'
import type { AppProps } from 'next/app'
import {BrandsIndexProps} from './[...index]'
import {useFormatCacheUrl} from '../utils/urlUtils'
import './_app.scss'

if (process.browser) {
  require('what-input')
}

function App({ Component, pageProps, router}: AppProps<BrandsIndexProps>): JSX.Element {
  useFormatCacheUrl({
    nextRouter: router,
    namespace: 'all-brands',
    isNma: pageProps.hideMarginals
  })
  return (
    <>
      <Component {...pageProps} />
    </>
  )
}

export default App
